import React, { useState } from 'react';
import { Input, Button, Popconfirm } from 'antd';
import styles from './LevelItem.module.css';
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
const LevelItem = ({ text, onSave, onDelete , order }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(text);
    const [loading , setLoading] = useState(false)
    return (
        <div
            className={styles.LevelItem}

        >
           
            {isEditing ? (
                <div>
                    <Input
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        autoFocus
                    />
                </div>
            ) : (
                <div className={styles.itemText} onClick={() => setIsEditing(true)}>
                   <b>{order}- </b> {value}
                </div>
            )}
            <div className={styles.Buttons}>
                {isEditing && <>
                    <Button type="primary" danger onClick={() => {
                        setIsEditing(false);
                        setValue(text)
                    }}>
                    
                        لغو</Button>
                    <Button disabled={`${value}`.trim().length === 0} type="primary" loading={loading} onClick={() => {
                        setLoading(true)
                        onSave(value ,() => { setIsEditing(false) } , ()=>{setLoading(false)})
                    }}>
                        
                        ذخیره</Button>

                </>}
                {!isEditing && <>
                    <Button type="default" onClick={() => setIsEditing(true)}><EditOutlined /> ویرایش  </Button>
                    <Popconfirm onConfirm={()=>{
                        setLoading(true)
                        onDelete(()=>{
                            setLoading(false)
                        })
                    }} title={`آیا مطمئن هستید که می‌خواهید "${text}" حذف کنید؟`}>
                        <Button loading={loading} danger ><DeleteOutlined /> حذف</Button>
                    </Popconfirm></>
                }


            </div>
        </div>
    );
};

export default LevelItem;